<template>
  <div class="smartsheetform">
    <div class="items smartsheetform">
      <div style="width: 250px">
        <img
          src="@/assets/images/resmed-logo-color.png"
          alt="Resmed product support"
          class="img-fluid mb-3"
        />
      </div>

      <div class="title mb-4">
        Resmed - Astral FSN - Field Action Tracking Form
      </div>
      <p class="text-center fw-bold">
        Follow the updated Astral Service process detailed in Tech Note 1063720,
        <br />
        and fill in required information below.
      </p>

      <p class="text-center fw-bold">
        All information provided will be processed in accordance with the Resmed
        Privacy Policy
        <br />
        (<a href="https://resmed.co.uk/privacy" target="_blank">
          Privacy notice: information on your rights | Resmed UK </a
        >)
      </p>

      <div
        class="item card-white"
        v-if="
          
          (role && role.includes('technical_approved')) ||
            role.includes('sleep_approved') ||
            role.includes('oxygen_approved') ||
            role.includes('ventilator_approved')
        "
      >
        <div class="smart-card margin-card">
          <form @submit.prevent="submit">
            <div class="form-container">
              <!-- Contact Email -->
              <div class="input-div">
                <label for="contact_email" class="mandatory">
                  Contact email
                </label>

                <input
                  id="contact_email"
                  v-model.trim="contact_email"
                  type="email"
                  name="contact_email"
                  class="input-height"
                  :class="{ 'is-invalid': validation.contact_email }"
                  @blur="validateField('contact_email')"
                />

                <span v-if="validation.contact_email" class="error">
                  {{ validation.contact_email }}
                </span>
              </div>

              <!-- Company Name -->
              <div class="input-div">
                <label for="company_name" class="mandatory">
                  Your Company Name
                </label>

                <input
                  id="company_name"
                  v-model.trim="company_name"
                  type="text"
                  name="company_name"
                  class="input-height"
                  :class="{ 'is-invalid': validation.company_name }"
                  @blur="validateField('company_name')"
                />

                <span v-if="validation.company_name" class="error">
                  {{ validation.company_name }}
                </span>
              </div>

              <!-- Country -->
              <div class="input-div">
                <label for="country" class="mandatory">
                  Country
                </label>

                <select
                  id="country"
                  v-model.trim="country"
                  name="country"
                  class="input-height"
                  :class="{ 'is-invalid': validation.country }"
                  @blur="validateField('country')"
                  @change="validateField('country')"
                >
                  <option disabled value="">Select a country</option>
                  <option v-for="c in countries" :key="c" :value="c">
                    {{ c }}
                  </option>
                </select>

                <span v-if="validation.country" class="error">
                  {{ validation.country }}
                </span>
              </div>

              <!-- Device Serial Number -->
              <div class="input-div">
                <label for="device_serial_number" class="mandatory">
                  Device Serial Number
                </label>

                <input
                  id="device_serial_number"
                  v-model.trim="device_serial_number"
                  type="text"
                  name="device_serial_number"
                  class="input-height-semi"
                  :class="{ 'is-invalid': validation.device_serial_number }"
                  @blur="validateField('device_serial_number')"
                />

                <span v-if="validation.device_serial_number" class="error">
                  {{ validation.device_serial_number }}
                </span>
              </div>

              <!-- Patient Criteria -->
              <div class="input-div">
                <label for="patient_criteria" class="mandatory">
                  Select the appropriate patient criteria per Astal-2026-FSN-01
                </label>

                <select
                  id="patient_criteria"
                  v-model="tier"
                  name="patient_criteria"
                  class="input-height"
                  :class="{ 'is-invalid': validation.tier }"
                  @blur="validateField('tier')"
                  @change="validateField('tier')"
                >
                  <option disabled value="">Select the patient criteria</option>
                  <option value="Tier 1 - Highest potential risk of harm">
                    Tier 1 - Highest potential risk of harm
                  </option>
                  <option value="Tier 2 - Moderate potential risk of harm">
                    Tier 2 - Moderate potential risk of harm
                  </option>
                   <option value="Tier 3 - Lower potential risk of harm">
                    Tier 3 - Lower potential risk of harm
                  </option>
                </select>

                <span v-if="validation.tier" class="error">
                  {{ validation.tier }}
                </span>
              </div>

              <!-- Tier 3 informational text -->
              <div v-if="isTier3" class="tier3-info">
                Leak inspection and serial number capture are not required for
                Tier 3 devices unless a device failure is identified.
              </div>

              <!-- Section A: Inspect for Leak -->
              <div
                class="device-status-container"
                :class="{ 'section-disabled': leakDisabled }"
              >
                <label class="mandatory">
                  Inspect for leak
                </label>

                <div>
                  <input
                    type="radio"
                    id="ds1"
                    value="Supercapacitor leak identified"
                    v-model="inspectLeak"
                    :disabled="leakDisabled"
                    @change="validateField('inspectLeak')"
                  />
                  <label for="ds1">
                    Supercapacitor leak identified
                  </label>
                </div>

                <div>
                  <input
                    type="radio"
                    id="ds2"
                    value="Supercapacitor leak not identified"
                    v-model="inspectLeak"
                    :disabled="leakDisabled"
                    @change="validateField('inspectLeak')"
                  />
                  <label for="ds2">
                    Supercapacitor leak not identified
                  </label>
                </div>

                <span v-if="validation.inspectLeak" class="error">
                  {{ validation.inspectLeak }}
                </span>
              </div>

              <!-- Section B: Device Failure -->
              <div class="device-status-container">
                <label>
                  Device Failure
                </label>

                <div class="checkbox-div">
                  <input
                    type="checkbox"
                    id="systemFault"
                    v-model="systemFault"
                  />
                  <label for="systemFault">
                    System fault (e.g., 394, 395, 396, 140, or other fault code)
                  </label>
                </div>

                <div class="checkbox-div">
                  <input
                    type="checkbox"
                    id="tpfFailure"
                    v-model="tpfFailure"
                  />
                  <label for="tpfFailure">
                    TPF failure (5-minute test)
                  </label>
                </div>
              </div>

              <!-- PCB Serial Number Section -->
              <div v-if="showPcbSection" class="alarm-testing-container">
                <!-- Old Serial -->
                <div class="input-div">
                  <label for="old_serial_no" class="mandatory">
                    Old Main PCBA serial number (on the PCB)
                  </label>

                  <input
                    id="old_serial_no"
                    :value="old_serial_no"
                    @input="onRawSerialInput('old_serial_no', $event)"
                    @blur="validateField('old_serial_no')"
                    type="text"
                    name="old_serial_no"
                    class="input-height"
                    maxlength="18"
                    placeholder="R2707658-2-5505631"
                    :class="{ 'is-invalid': validation.old_serial_no }"
                  />

                  <span v-if="validation.old_serial_no" class="error">
                    {{ validation.old_serial_no }}
                  </span>
                </div>

                <!-- New Serial + Awaiting Parts -->
                <div class="input-div">
                  <label for="new_serial_no" class="mandatory">
                    New Main PCBA serial number (on the PCB)
                  </label>

                  <input
                    id="new_serial_no"
                    :value="new_serial_no"
                    @input="onRawSerialInput('new_serial_no', $event)"
                    @blur="validateField('new_serial_no')"
                    type="text"
                    name="new_serial_no"
                    class="input-height"
                    maxlength="18"
                    placeholder="R2707658-2-5505631"
                    :disabled="awaitingParts"
                    :class="{ 'is-invalid': validation.new_serial_no }"
                  />

                  <span v-if="validation.new_serial_no" class="error">
                    {{ validation.new_serial_no }}
                  </span>

                  <div class="checkbox-div awaiting-parts">
                    <input
                      type="checkbox"
                      id="awaitingParts"
                      v-model="awaitingParts"
                    />
                    <label for="awaitingParts">
                      Awaiting Parts
                    </label>
                  </div>
                </div>

                <!-- PCB Serial (carton) -->
                <div class="input-div">
                  <label for="new_pcb_Serial_no" class="mandatory">
                    Main PCB serial number (printed on the carton)
                  </label>

                  <input
                    id="new_pcb_Serial_no"
                    v-model.trim="new_pcb_Serial_no"
                    type="text"
                    name="new_pcb_Serial_no"
                    class="input-height"
                    maxlength="11"
                    :disabled="awaitingParts"
                    :class="{ 'is-invalid': validation.new_pcb_Serial_no }"
                    @blur="validateField('new_pcb_Serial_no')"
                  />

                  <span v-if="validation.new_pcb_Serial_no" class="error">
                    {{ validation.new_pcb_Serial_no }}
                  </span>
                </div>
              </div>

              <div class="border-div"></div>

              <!-- Terms -->
              <div class="checkbox-div">
                <input type="checkbox" id="termsAgree" v-model="termsAgree" @change="validateField('termsAgree')" />

                <label for="termsAgree">
                  By selecting/checking this box, I certify that the patient
                  using this device meet the patient prioritization criteria
                  defined in Astral-2026-FSN-01
                </label>

                <div v-if="validation.termsAgree" class="error">
                  {{ validation.termsAgree }}
                </div>
              </div>

              <!-- Email Copy -->
              <div class="checkbox-div">
                <input
                  type="checkbox"
                  id="emailVerification"
                  v-model="emailVerification"
                />

                <label for="emailVerification">
                  Send me a copy of my responses
                </label>
              </div>

              <!-- Servicing Agent -->
              <div class="input-div">
                <label for="servicing_agent" class="mandatory">
                  Servicing Agent
                </label>

                <input
                  id="servicing_agent"
                  v-model.trim="servicing_agent"
                  type="text"
                  name="servicing_agent"
                  class="input-height"
                  :class="{ 'is-invalid': validation.servicing_agent }"
                  @blur="validateField('servicing_agent')"
                />

                <span v-if="validation.servicing_agent" class="error">
                  {{ validation.servicing_agent }}
                </span>
              </div>

              <!-- Submit -->
              <div class="submit-btn-wrap">
                <button
                  type="submit"
                  class="submit-btn"
                  :disabled="status.submitting"
                >
                  {{ status.submitting ? "Submitting..." : "Submit" }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "SmartSheetFormExternal",

  data() {
    return {
      contact_email: "",
      company_name: "",
      country: "",
      inspectLeak: "",
      device_serial_number: "",
      tier: "",
      old_serial_no: "",
      new_pcb_Serial_no: "",
      new_serial_no: "",
      servicing_agent: "",

      systemFault: false,
      tpfFailure: false,
      awaitingParts: false,

      emailVerification: false,
      termsAgree: false,

      validation: {},

      status: {
        errors: false,
        submitting: false,
        success: false,
        errorMessage: null,
      },
      countries: [
        "Argentina",
        "Australia",
        "Austria",
        "Bahrain",
        "Bangladesh",
        "Belgium",
        "Bhutan",
        "Brazil",
        "Bulgaria",
        "Canada",
        "Chile",
        "Colombia",
        "Croatia",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Ecuador",
        "Estonia",
        "Finland",
        "France",
        "Germany",
        "Greece",
        "Guatemala",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Italy",
        "Japan",
        "Kenya",
        "Korea",
        "Kuwait",
        "Latvia",
        "Lebanon",
        "Lithuania",
        "Malaysia",
        "Maldives",
        "Malta",
        "Mauritius",
        "Mexico",
        "Myanmar",
        "Nepal",
        "Netherlands",
        "New Zealand",
        "Norway",
        "Oman",
        "Panama",
        "Peru",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Romania",
        "Singapore",
        "Slovenia",
        "South Africa",
        "Spain",
        "Sri Lanka",
        "Sweden",
        "Switzerland",
        "Taiwan",
        "Egypt",
        "Israel",
        "Jordan",
        "Morocco",
        "Saudi Arabia",
        "Iran",
        "Pakistan",
        "Indonesia",
        "Phillipines",
        "Algeria",
        "United States",
        "United Kingdom"
      ],
      role: $cookies.get("role") || "",
    };
  },

  computed: {
    isTier3() {
      return this.tier === "Tier 3 - Lower potential risk of harm";
    },

    hasDeviceFailure() {
      return this.systemFault || this.tpfFailure;
    },

    leakDisabled() {
      return this.isTier3 && !this.hasDeviceFailure;
    },

    showPcbSection() {
      if (this.isTier3) {
        return this.hasDeviceFailure;
      }
      return (
        this.inspectLeak !== "Supercapacitor leak not identified" ||
        this.hasDeviceFailure
      );
    },
  },

  watch: {
    leakDisabled(disabled) {
      if (disabled) {
        this.inspectLeak = "";
        this.$set(this.validation, "inspectLeak", null);
      }
    },

    awaitingParts(awaiting) {
      if (awaiting) {
        this.new_serial_no = "";
        this.$set(this.validation, "new_serial_no", null);
        this.new_pcb_Serial_no = "";
        this.$set(this.validation, "new_pcb_Serial_no", null);
      }
    },
  },

  async mounted() {
    const useremail = $cookies.get("rocEmail");
    const usersid = $cookies.get("rocSid");
    const role = $cookies.get("role");

    const hasAccess = decodeURIComponent(role)
      .split(",")
      .some((r) =>
        [
          "technical_approved",
          "sleep_approved",
          "oxygen_approved",
          "ventilator_approved",
        ].includes(r),
      );

    if(role && !hasAccess) {
      Swal.fire({
        title: "Access Denied",
        text: "You do not have the required role to access this form.",
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        window.location.href = "/";
      });
    }

    if(!useremail || !usersid || !hasAccess) {
        let region = "en-us"
        try{
          if(this.$route)  
         region = this.$route.params.region
        }
        catch(e){ region = "en-us"}
        window.location.href = `${process.env.VUE_APP_ROCUI_ENDPOINT}/${region || "en-us"}?redirect_to=${encodeURIComponent(window.location.href)}`;
    }
  },

  methods: {
    formatRawSerial(value) {
      // Strip everything except letters/digits, then auto-insert the two
      // hyphens to build the R-number format: R2707658-2-5505631
      let raw = (value || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
      raw = raw.slice(0, 16);

      if (raw.length > 9) {
        return `${raw.slice(0, 8)}-${raw.slice(8, 9)}-${raw.slice(9)}`;
      }
      if (raw.length > 8) {
        return `${raw.slice(0, 8)}-${raw.slice(8)}`;
      }
      return raw;
    },

    onRawSerialInput(field, event) {
      const formatted = this.formatRawSerial(event.target.value);
      this[field] = formatted;
      event.target.value = formatted;
    },

    validateField(fieldName) {
      let error = null;
      const value = this[fieldName];

      switch (fieldName) {
        case "contact_email":
          if (!value) {
            error = "Email is required";
          } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            error = "Invalid email format";
          }
          break;

        case "company_name":
          if (!value) {
            error = "Company name is required";
          }
          break;

        case "country":
          if (!value) {
            error = "Country is required";
          }
          break;

        case "device_serial_number":
          if (!value) {
            error = "Device serial number is required";
          } else if (!/^\d{11}$/.test(value)) {
            error = "Device serial number must contain exactly 11 digits";
          }
          break;

        case "tier":
          if (!value) {
            error = "Patient criteria is required";
          }
          break;

        case "inspectLeak":
          if (!this.leakDisabled && !value) {
            error = "Please select leak status";
          }
          break;

        case "old_serial_no":
          if (this.showPcbSection && !value) {
            error = "Old Main PCBA serial number is required";
          } else if (
            this.showPcbSection &&
           !/^R[A-Za-z0-9]{7}-[A-Za-z0-9]-[A-Za-z0-9]{7}$/.test(value)
          ) {
            error =
              "Enter a valid serial number in the format R2707658-2-5505631";
          }
          break;

        case "new_serial_no":
          if (this.awaitingParts) {
            break;
          }
          if (this.showPcbSection && !value) {
            error = "New Main PCBA serial number is required";
          } else if (
            this.showPcbSection &&
            !/^R[A-Za-z0-9]{7}-[A-Za-z0-9]-[A-Za-z0-9]{7}$/.test(value)
          ) {
            error =
              "Enter a valid serial number in the format R2707658-2-5505631";
          }
          break;

        case "new_pcb_Serial_no":
          if (this.awaitingParts) {
            break;
          }
          if (this.showPcbSection && !value) {
            error = "Main PCB serial number is required";
          } else if (this.showPcbSection && !/^\d{11}$/.test(value)) {
            error = "Main PCB serial number must contain exactly 11 digits";
          } else if (this.showPcbSection && /^(20|21)/.test(value)) {
            error =
              "Main PCB serial number (Box Number) cannot begin with 20 or 21";
          }
          break;

        case "servicing_agent":
          if (!value) {
            error = "Servicing agent is required";
          }
          break;

        case "termsAgree":
          if (!this.termsAgree) {
            error = "You must acknowledge the checkbox";
          }
          break;

        default:
          break;
      }

      this.$set(this.validation, fieldName, error);

      return !error;
    },

    validateForm() {
      this.validation = {};

      const fieldsToValidate = [
        "contact_email",
        "company_name",
        "country",
        "device_serial_number",
        "tier",
        "servicing_agent",
        "termsAgree",
      ];

      if (!this.leakDisabled) {
        fieldsToValidate.push("inspectLeak");
      }

      if (this.showPcbSection) {
        fieldsToValidate.push(
          "old_serial_no",
          "new_serial_no",
          "new_pcb_Serial_no",
        );
      }

      const validationResult = fieldsToValidate.map((field) =>
        this.validateField(field),
      );

      const isValid = validationResult.every(Boolean);

      this.status.errors = !isValid;

      return isValid;
    },

    async submit() {
      if (!this.validateForm()) {
        return;
      }

      this.status.submitting = true;
      this.status.success = false;
      this.status.errorMessage = null;

      if (!this.showPcbSection) {
        this.old_serial_no = "";
        this.new_serial_no = "";
        this.new_pcb_Serial_no = "";
      }

      if (this.awaitingParts) {
        this.new_serial_no = "";
        this.new_pcb_Serial_no = "";
      }

      // Old Raw Serial Number --> ATTRIBUTE4
      // New Raw Serial Number --> ATTRIBUTE15
      // PCBA Serial Number --> Serial Number

      const current_user = $cookies.get("rocEmail") || "";

      const payload = {
        data: {
          contact_email: this.contact_email,
          company_name: this.company_name,
          country: this.country,
          device_serial_number: this.device_serial_number,
          tier: this.tier,
          inspectLeak: this.inspectLeak,
          system_fault: this.systemFault,
          tpf_failure: this.tpfFailure,
          awaiting_parts: this.awaitingParts,
          old_serial_no: this.old_serial_no,
          new_serial_no: this.new_serial_no,
          new_pcb_Serial_no: this.new_pcb_Serial_no,
          servicing_agent: this.servicing_agent,
          send_email: this.emailVerification,
          current_user: current_user,
          source_system: "support.resmed.com",
        },
      };

      try {
        const response = await fetch(
          `${
            process.env.VUE_APP_GPSPOD_ENDPOINT
          }/gps/home/uploadForm?tsv_service_activity=true`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          },
        );

        if (!response.ok) {
          throw new Error("Failed to submit");
        }

        await response.json();

        this.status.success = true;
        console.log("Payload - ", payload);

        Swal.fire({
          title: "Success!",
          text: "Form submitted successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });

        this.resetForm();
      } catch (error) {
        this.status.errorMessage = "Failed to submit the form.";

        Swal.fire({
          title: "Error!",
          text: "Failed to submit the form.",
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        this.status.submitting = false;
      }
    },

    resetForm() {
      this.contact_email = "";
      this.company_name = "";
      this.country = "";
      this.inspectLeak = "";
      this.device_serial_number = "";
      this.tier = "";
      this.old_serial_no = "";
      this.new_serial_no = "";
      this.new_pcb_Serial_no = "";
      this.servicing_agent = "";
      this.systemFault = false;
      this.tpfFailure = false;
      this.awaitingParts = false;
      this.emailVerification = false;
      this.termsAgree = false;
      this.validation = {};
    },
  },
};
</script>

<style scoped>
.container.smartsheetform {
  margin: 40px;
}

.mandatory::after {
  content: " *";
  color: rgb(208, 1, 27);
}

.form-container {
  padding: 30px 25px;
}

.title {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
}

.alarm-testing-container {
  margin-top: 10px;
}

.items.smartsheetform {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.card-white {
  width: 600px;
  height: 100%;
}

.smart-card {
  width: 600px;
}

.input-div {
  margin-bottom: 15px;
}

.checkbox-div {
  margin-bottom: 15px;
}

.border-div {
  border-bottom: 2px solid lightgray;
  margin: 20px 0px;
}

.submit-btn {
  padding: 10px 20px;
  background-color: rgb(0, 115, 236);
  color: white;
  border-radius: 2px;
  border: none;
  cursor: pointer;
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.submit-btn-wrap {
  margin: 20px 0px;
}

.input-height {
  width: 550px;
  height: 36px;
  padding: 5px 10px;
}

.input-height-semi {
  width: 250px;
  height: 36px;
  padding: 5px 10px;
}

.is-invalid {
  border: 1px solid rgb(208, 1, 27);
}

.error {
  color: rgb(208, 1, 27);
  font-size: 13px;
  margin-top: 4px;
  display: block;
}

.device-status-container {
  margin-bottom: 20px; 
}

.section-disabled {
  opacity: 0.5;
  pointer-events: none;
}

.tier3-info {
  background: #eef4ff;
  border-left: 4px solid rgb(0, 115, 236);
  padding: 10px 12px;
  margin-bottom: 20px;
  font-size: 14px;
}

.awaiting-parts {
  margin-top: 8px;
}
</style>
